import AddCircleIcon from '@mui/icons-material/AddCircle';
import { getRoute } from '@common/constants/CampusRoutes';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import StyledGoalsFormCreateItemWrap from './styled';

function GoalsFormCreateItem() {
	const navigate = useNavigate();

	const handleClick = () => {
		navigate(getRoute(['REPORT', 'ABOUT', 'STEPS', 'CREATE']));
	};

	return (
		<StyledGoalsFormCreateItemWrap onClick={handleClick}>
			<AddCircleIcon color="primary" sx={{ fontSize: '40px' }} />
		</StyledGoalsFormCreateItemWrap>
	);
}

export default GoalsFormCreateItem;
